
import { LayoutCrearDoc } from "../../layouts"
import { TablaListadoUsuarios } from "../components"
import { useNavigate } from "react-router-dom";
import { useListUserXRole } from "../../../hooks/cache";
import { BuscadorXTermino } from "../../components/buscadores";
import { CargandoMedio } from "../../components";






export const ListadoDeColaboradores = () => {


    const navigate = useNavigate();
    const { data, isLoading, page, 
            termino, chagePage, chageTermino } = useListUserXRole(['DISENIADOR', 'PRODUCCION', 'MARKETING']);
    
        
    const handleNavegar = () => {
        navigate(`/super/crearUsuario`);
    }


    return (

        <LayoutCrearDoc titulo='Listado de Colaboradores' funcion={ handleNavegar }>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de colaboradores..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="socio" playhol="nombre ciudad movil cedula" />
                <TablaListadoUsuarios data={data || []} chagePage={chagePage} page={page} />
                </>
            }
        </LayoutCrearDoc>

    )



    
}
